// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard2":"styles_componentsMapCard2__3E-qL","merchantName":"styles_merchantName__3rYnB","fixToBottom":"styles_fixToBottom__16Sz6"};